<!--  -->
<template>
  <div class="welfare">
    <h1 class="welfare-title" v-if="isshow == 1">{{ title }}</h1>
    <ul class="welfare-list">
      <li v-for="(item, index) in welfareList" :key="index">
        <div class="welfare-logo">
          <img :src="item.src" />
          <h1>{{ item.title }}</h1>
        </div>
        <p>{{ item.msg }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      isshow: 1,
      title: "", //公司福利
      welfareList: [
        /* 
        {
          src: require("../../assets/welfare1.png"),
          title: "体检",
          msg: "入职满一年，每年享有年度体检",
        },
        {
          src: require("../../assets/welfare1.png"),
          title: "加薪",
          msg: "按照国家规定缴纳社保公积金、享有年度调薪",
        },
        {
          src: require("../../assets/welfare1.png"),
          title: "培训",
          msg: "公司提供入职培训、专业培训（包括网课、讲座），另外自考工作相关证书公司也可报销学费，鼓励员工多多学习入职满一年，每年享有年度体检 ",
        },
        {
          src: require("../../assets/welfare1.png"),
          title: "假期",
          msg: "按照国家规定给到年假，每位员工额外会享有12天带薪病假",
        },
        {
          src: require("../../assets/welfare1.png"),
          title: "团建",
          msg: "平均每个月会有活动，如七夕情人节活动，女神节活动等",
        },
        {
          src: require("../../assets/welfare1.png"),
          title: "礼物",
          msg: "生日、端午、中秋、过年都会有礼物 ",
        },
       */
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //得到福利
    get_list() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 16,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.title = obj.yj_name;
            $.each(obj.data, function (i, k) {
              that.welfareList.push({
                src: k.pic_f,
                title: k.title,
                msg: k.msgs,
              });
            });

            if (that.welfareList.length <= 0) {
              that.isshow = 0;
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_list();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.welfare {
  width: $main-width;
  margin: 20px auto;
  .welfare-title {
    text-align: center;
    color: #193b95;
    font-size: 1.4rem;
  }
  .welfare-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      margin-top: 100px;
      width: 31%;
      height: 238px;
      background: #fffef3;
      border: 1px solid #f8ad17;
      position: relative;
      padding: 0 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .welfare-logo {
        width: 30%;
        height: 123px;
        background: #fffef3;
        border: 1px solid #f8ad17;
        border-radius: 50%;
        position: absolute;
        top: -61.5px;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-top: 15px;
        }
        h1 {
          position: absolute;
          font-size: 0.8rem;
          color: #f8ad17;
          bottom: 26px;
        }
      }
      p {
        margin-top: 40px;
        display: block;
        text-align: center;
        font-size: 1rem;
        color: #f8ad17;
        line-height: 1.4rem;
        overflow-y: auto;
        height: 140px;
      }
      p::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      p::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background: #f8ad17;
      }
      p::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: #e5e5e5;
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .welfare {
    width: 100%;
    .welfare-list {
      flex-wrap: wrap;
      justify-content: center;
      li {
        width: 90%;
        .welfare-logo {
          width: 123px;
          height: 123px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/joinUs/CorporateWelfare.vue